// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__3Hlpb","default":"Input_default__3Mj9b","label":"Input_label__1skz6","large":"Input_large__2dLuo","small":"Input_small__3Em5K"};